import { Component } from '@angular/core';

@Component({
    selector: 'app-logo',
    standalone: true,
    styles: ['#app-logo {margin-right: 0.5em;}'],
    template: `
        <svg id="app-logo" width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_662_1275)">
                <path
                    d="M49.8041 20.6948C49.7818 20.9315 49.7484 21.1659 49.695 21.398C48.9379 24.6217 47.014 27.1198 44.6914 29.3969C41.5361 32.4933 38.4342 35.6455 35.3056 38.7687C35.0562 39.0165 34.8535 39.3402 34.3481 39.4674C40.0063 24.7043 37.0402 12.4325 24.2585 2.79956C26.256 3.30409 28.2578 3.793 30.2486 4.31762C33.2614 5.11014 36.2764 5.90489 39.2781 6.73982C43.538 7.92748 47.0273 10.0929 48.8176 14.3949C49.263 15.4664 49.5569 16.5961 49.7707 17.71C49.9533 18.9223 49.8932 19.7483 49.8041 20.697V20.6948Z"
                    fill="#C6093B"
                />
                <path
                    d="M14.365 0.296974C15.2534 0.408596 21.4194 2.78168 24.4522 5.0744C24.6593 5.23067 24.8664 5.38917 25.0757 5.54098C25.7772 6.05221 25.6458 6.35582 24.8642 6.60585C22.1987 7.45642 19.6959 8.653 17.3666 10.2135C12.1026 13.7385 8.58647 18.5628 6.69149 24.6016C6.56679 24.9989 6.61578 25.6196 6.11921 25.691C5.72061 25.749 5.50462 25.2177 5.25299 24.9074C2.83026 21.9249 0.950863 18.6744 0.336273 14.8078C0.0668331 13.0844 0.00671016 12.1245 0.336273 10.343C1.49197 5.58116 4.25985 2.3977 8.6221 0.779182C9.67091 0.388504 10.7732 0.142936 11.891 0.116146C12.7216 0.0960545 13.5255 0.167493 14.365 0.296974Z"
                    fill="#C6093B"
                />
                <path
                    d="M2.9126 24.1484C3.62071 25.0459 4.25757 25.8987 4.94119 26.7113C12.2205 35.3464 21.3815 38.6615 32.4842 36.4916C32.8894 36.4135 33.4083 36.063 33.7133 36.4715C33.9583 36.8019 33.5842 37.2395 33.4328 37.6101C31.9564 41.24 29.9367 44.5195 26.9128 47.0578C20.9873 52.0294 11.9756 50.2256 8.31475 43.3876C7.46635 41.8026 6.88516 40.1238 6.4309 38.3914C5.2997 34.0761 4.15068 29.7653 3.02616 25.45C2.92819 25.0749 2.9126 24.1484 2.9126 24.1484Z"
                    fill="#C6093B"
                />
            </g>
            <defs>
                <clipPath id="clip0_662_1275">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    `
})
export class LogoComponent {}
